import { Button } from '@bluebeam/react-skyline-button';
import LoadingAnimation from 'components/LoadingAnimation';
import * as React from 'react';
import { LoginMachineServiceProvider } from './LoginMachineServiceProvider';
import { useLoginMachine } from './useLoginMachine';

const isLoggedIn = (state: ReturnType<typeof useLoginMachine>[0]) => {
  return (
    state.matches('loggedIn') ||
    state.matches({ loggedInWithRefresh: 'idle' }) ||
    state.matches({ loggedInWithRefresh: 'refreshingTokens' })
  );
};

export const AuthenticationGuard: React.FC = ({ children }) => {
  const [state, , service] = useLoginMachine();

  if (isLoggedIn(state)) {
    return (
      <LoginMachineServiceProvider value={service}>
        {children}
      </LoginMachineServiceProvider>
    );
  }

  const renderContent = () => {
    if (state.value === 'failed') {
      return (
        <header
          css={{
            textAlign: 'center',
          }}
        >
          <h2
            css={{
              marginBottom: '32px',
            }}
          >
            {state.context.error}
          </h2>
          <Button
            onClick={() => {
              window.location.href = window.location.origin;
            }}
            type="button"
            variant="text"
          >
            Refresh
          </Button>
        </header>
      );
    }

    return <LoadingAnimation loadingMessageKey="loading" />;
  };

  return (
    <main
      css={{
        alignItems: 'center',
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        height: '100vh',
        justifyContent: 'center',
        padding: '2rem',
      }}
    >
      {renderContent()}
    </main>
  );
};

export default AuthenticationGuard;
